import { useEffect, useState } from "react";
import { slides } from "../Data/datas";

const Slides = ({ children }) => {
  const [toggle, setToggle] = useState(1);
  const [prevToggle, setPrevToggle] = useState(1);
  const [direction, setDirection] = useState("next");
  const [transitioning, setTransitioning] = useState(false);

  const handleSlide = (id) => {
    if (transitioning) return;
    setPrevToggle(toggle);
    setDirection(id > toggle ? "next" : "prev");
    setToggle(id);
  };

  useEffect(() => {
    const Interval = setInterval(() => {
      if (!transitioning) {
        setPrevToggle(toggle);
        setDirection("next");
        toggle < slides.length ? setToggle(toggle + 1) : setToggle(1);
      }
    }, 5000);

    return () => clearInterval(Interval);
  }, [toggle, transitioning]);

  const handleTransitionStart = () => {
    setTransitioning(true);
  };

  const handleTransitionEnd = () => {
    setTransitioning(false);
  };

  return (
    <div className="w-full flex flex-col gap-3 justify-between min-h-screen relative overflow-hidden">
      {/* Background layers */}
      {slides.map((slide) => (
        <div
          key={slide.id}
          className={`absolute top-0 left-0 w-full h-full bg-cover bg-no-repeat transition-all duration-1000 ease-in-out ${
            slide.id === toggle
              ? "opacity-100 z-10"
              : slide.id === prevToggle
              ? "opacity-0 z-0"
              : "opacity-0 -z-10"
          } ${
            slide.id === toggle && direction === "next"
              ? "animate-fade-in-right"
              : slide.id === toggle && direction === "prev"
              ? "animate-fade-in-left"
              : slide.id === prevToggle && direction === "next"
              ? "animate-fade-out-left"
              : slide.id === prevToggle && direction === "prev"
              ? "animate-fade-out-right"
              : ""
          }`}
          style={{
            backgroundImage: `url(${slide.image})`,
            transform: `${
              slide.id === toggle
                ? "translate3d(0, 0, 0)"
                : slide.id === prevToggle && direction === "next"
                ? "translate3d(-100%, 0, 0)"
                : slide.id === prevToggle && direction === "prev"
                ? "translate3d(100%, 0, 0)"
                : direction === "next"
                ? "translate3d(100%, 0, 0)"
                : "translate3d(-100%, 0, 0)"
            }`,
          }}
          onTransitionStart={handleTransitionStart}
          onTransitionEnd={handleTransitionEnd}
        />
      ))}

      {/* Content and navigation */}
      <div className="relative z-20">{children}</div>
      <div className="flex gap-1 justify-center end relative z-20">
        {slides.map((slide) => (
          <button
            key={slide.id}
            onClick={() => handleSlide(slide.id)}
            className={`${
              slide.id === toggle ? "bg-[#66B2FF]" : "bg-gray-400"
            } rounded-full outline-none border-none sm:p-2 p-[0.35rem] transform transition-colors duration-300 hover:bg-[#3b76db]`}
            aria-label={`Go to slide ${slide.id}`}
            disabled={transitioning}
          ></button>
        ))}
      </div>

   
    </div>
  );
};

export default Slides;
